import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Text from 'components/common/Text/Text'
import RecommendedService from './components/RecommendedService'
import { arrayHasValues } from 'helpers/utils'

const BOTRecommendedProductService = ({
  title,
  recentlyAddedSku: {
    recommendedSkus = []
  } = {}
}) =>
  arrayHasValues(recommendedSkus) &&
    <Fragment>
      <ScrollableWrapper>
        <Title block narrow follow_link data-at-title>{ title }</Title>
        {
          recommendedSkus.map((service, index) =>
            <RecommendedService key={ index } { ... service } />)
        }
      </ScrollableWrapper>
    </Fragment>

export default BOTRecommendedProductService

BOTRecommendedProductService.propTypes = {
  recentlyAddedSku: PropTypes.shape({
    recommendedSkus: PropTypes.arrayOf(PropTypes.shape())
  }),
  title: PropTypes.string
}

const Title = styled(Text)`
  border-top: 1px solid ${Theme.colors.light_grey};
  ${Media.mobile`
    font-size: 22px;
  `}
  ${Mixin.responsive('padding', '22px 0 0', '27px 0 0')}
`

const ScrollableWrapper = styled.div`
  overflow: auto;
  flex-grow: 1;
  padding-right: 15px;
`
